import React from "react";
import { checkTemp, composeValidators, required } from "../../../helpers/formValidators";

import { FormLabel, FormInput } from "../../form";

export default () => {
  return (
    <FormInput
      name="temperature"
      labelRenderer={() => <FormLabel for="temperature">Temperature</FormLabel>}
      measurement="Celsius"
      initialValue="36"
      type="number"
      validate={composeValidators(required, checkTemp)}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/ActivityTracker/FieldExcerpts/Temperature.js